<template>
  <component :is="component" :to="to ?? link" v-if="to || link" class="beet-link">
    <span class="text" v-if="label">{{ label }}</span>
    <Icon v-if="icon" :class="icon" :id="icon"/>
  </component>
</template>

<script>
import {Icon, LangRouterLink} from '@/components/global'
import {RouterLink} from 'vue-router'

export default {
  name: 'SiteLink',
  components: {
    Icon
  },
  props: {
    icon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    link: {
      type: String,
      default: null
    },
    to: {
      type: Object,
      default: null
    },
  },
  computed: {
    component() {
      return this.link ? RouterLink : LangRouterLink
    }
  }
}
</script>